import angular from "angular";

import BicycleOwnerServiceProvidersModuleRouting from "./bicycle-owner-service-providers.module.routing";

export default angular
  .module("vt-bicycle-owner-service-providers", [])
  .config(BicycleOwnerServiceProvidersModuleRouting);
